<template>

  <div class="page-user-list">
	
	<b-card no-body>
	  <b-card-body>
	    <b-form>
		  <b-row>
		    <b-col md="4">
			  <b-form-group :label="$t('User Name')">
				<b-form-input
				:placeholder="$t('Please input')+$t('User Name')"
				v-model="filter.Keyword"/>  
			  </b-form-group>	  
		    </b-col>
			
			<b-col md="12">
			  <b-button
			      variant="primary"
			      class="mr-1"
				  @click="onSearch()"
			  >
			    {{$t("Search")}}
			  </b-button>
			  <b-button
			      type="reset"
			      variant="outline-secondary"
				  @click="onReset()"
			  >
				{{$t("Reset")}}
			  </b-button>
			</b-col>
		    
		  </b-row>
		</b-form>  
	  </b-card-body>
	</b-card>	
	  
	<b-card no-body>
		  
		<div class="m-2">
		
		  <b-row>
		
		    <!-- 筛选 -->
		    <b-col
		      cols="12"
		    >
		      <div class="d-flex align-items-center justify-content-first">
		        <!--<v-select
		          v-model="filter.group"
		          :options="groupOptions"
		          class="filter-select mr-1"
		          placeholder="Select Group"
		        >
		        </v-select>-->
				<b-button
				    variant="primary"
				    :to="{ name: 'users-user-add'}"
				>
				  {{$t('Add User')}}
				</b-button>
	
		      </div>
		    </b-col>
		  </b-row>
		
		</div>
		
		
		<b-table
		  :items="users"
		  responsive
		  :fields="columns"
		  primary-key="id"
		  show-empty
		  :empty-text="$t('No matching records found')"
		  class="position-relative"
		  sort-icon-left
		  @sort-changed="handleSortChange"
		>
		  <!-- 列: 角色 -->
		  <template #cell(roleIdentifier)="data">
		    {{ data.item.dicUserRoles?data.item.dicUserRoles.userRolesString:'' }}
		  </template>
		
		  <!-- 列: 操作按钮 -->
		  <template #cell(actions)="data">
		
		    <div class="text-nowrap">
		
			  <a
			  @click="$router.push({ name: 'users-user-edit', params: { name: data.item.userName }})"
			  >
			    <feather-icon
			    icon="EditIcon" />
			    <span class="align-middle ml-50">{{$t("Edit")}}</span>	
			  </a>
			  
			  <a @click="onClickDel(data.index, data.item.userName)" >
			  	<feather-icon class="ml-2" icon="TrashIcon" />
			  	<span class="align-middle ml-50">{{$t("Delete")}}</span>
			  </a>
		     
		    </div>
		  </template>
		
		</b-table>
		
		
		<div class="mx-2 mb-2">
		    <b-row>
		      <!-- 页码 -->
		      <b-col
		        cols="12"
		        sm="12"
		        class="d-flex align-items-center justify-content-center justify-content-sm-start"
		      >
		
		        <b-pagination
		          v-model="filter.Page"
		          :total-rows="total"
		          :per-page="filter.Size"
		          first-number
		          last-number
		          class="mb-0 mt-1 mt-sm-0"
		          prev-class="prev-item"
		          next-class="next-item"
				  @change="onClickPage"
		        >
		          <template #prev-text>
		            <feather-icon
		              icon="ChevronLeftIcon"
		              size="18"
		            />
		          </template>
		          <template #next-text>
		            <feather-icon
		              icon="ChevronRightIcon"
		              size="18"
		            />
		          </template>
		        </b-pagination>
		
		      </b-col>
		
		    </b-row>
		</div>
		
	</b-card>  
	  
	  
  </div>
	
</template>

<script>
import {
  BCard, BCardBody, BForm, BTable, BLink, BDropdown, BDropdownItem, BTooltip, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getDeviceStatus,getOnlineDevices,getOfflineDevices } from '@/api/device'
import { getUsers, getUserGroupOptions, delUser } from '@/api/user'


export default {
  components: {
    BCard,
	BCardBody,
	BForm,
	BTable,
	BLink,
	BDropdown,
	BDropdownItem,
	BTooltip,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
	vSelect,
  },
  data() {
    return {
	  //用户列表	
	  users:[],	
	  //用户组选项
	  groupOptions:[],
	  //列表项总数
	  total:0,
      //列表筛选参数
      filter:{
        Page:1,
        Size:20,
		group:null,
		Keyword:null,
      },
	  //表格列结构
      columns: [
		{ key: 'userName', label: this.$t('User Name'), sortable: true },
		{ key: 'email', label: this.$t('Email'), sortable: true },
		{ key: 'group', label: this.$t('Group'), sortable: true },
		{ key: 'roleIdentifier', label: this.$t('Role'), sortable: true },
		{ key: 'firstName', label: this.$t('First Name'), sortable: true },
		{ key: 'lastName', label: this.$t('Last Name'), sortable: true },
		{ key: 'company', label: this.$t('Company'), sortable: true },
		{ key: 'department', label: this.$t('Department'), sortable: true },
		{ key: 'actions', label: this.$t('Actions') },
      ],
	  //角色选项
	  roleOptions:[
		  { label: '普通用户', value: 1 },
		  { label: '管理员', value: 2 },
	  ],
    }
  },
  created() {
	this.getUsers()
	this.getUserGroupOptions()
  },
  methods: {
	//获取用户列表
	getUsers(){
	  getUsers(this.filter).then(response => { 
		this.users = response.data
		this.total = response.count
	  })
	},
	//点击分页
	onClickPage(page){
	  this.filter.Page = page
	  this.getUsers()
	},
	//获取组下拉选项
	getUserGroupOptions(){
	  getUserGroupOptions(this.filter).then(response => { 
		this.groupOptions = response.data
	  })
	},
	//删除用户
	onClickDel(index, name){

	  this.$bvModal
	    .msgBoxConfirm(this.$t('Please confirm will delete?'), {
	      size: 'sm',
	      okVariant: 'primary',
	      okTitle: this.$t('Confirm'),
	      cancelTitle: this.$t('Cancel'),
	      cancelVariant: 'outline-secondary',
	      hideHeaderClose: false,
	      centered: true,
	    })
	    .then(value => {
	      if(value){
	  		this.users.splice(index, 1)
	  		delUser(name).then(response => {
              this.$toast.success(this.$t('Delete Success'))
            })
	  	}
	  })	
		  	
	},
	//排序
	handleSortChange(e){
	  this.filter.PropertyName = e.sortBy
	  this.filter.IsDesc = e.sortDesc
	  this.users = []
	  this.getUsers()
	},
	//搜索
	onSearch(){
	  this.users = []
	  this.getUsers()
	},
	//重置
	onReset(){
	  this.filter = {
	  	Page:1,
	  	Size:20,
	  	group:null,
	  	Keyword:null,
	  }
	  this.users = []
	  this.getUsers()
	},
	  
  },
}
</script>
<style lang="scss" scoped>

.filter-select {
  min-width: 290px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 200px;
  }
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
